<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Audit Log</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button>
    </div>
  </div>
  <app-audit-log-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (auditLogSearchFilter)="onSearchFilterChange($event)">
  </app-audit-log-search-box>
  <app-generic-list
    [items]="auditLogs"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50, 100]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [currentPage]="currentPage - 1"
    [enableView]="true"
    [enableLink]="true"
    linkTooltip="View change set"
    [rowAccentFn]="rowAccentFn"
    [sortActive]="sortBy"
    [sortDirection]="ascending ? 'asc' : 'desc'"
    (viewClick)="onViewChanges($event)"
    (linkClick)="onViewChangeSet($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</div>
